var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.portfolio) ? _c('div', {
    class: {
      'active': _vm.currentPage == 'portfolio-content'
    },
    attrs: {
      "id": "portfolio-content"
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('div', {
    staticClass: "portfolio"
  }, _vm._l((_vm.projects.item), function(project) {
    return _c('Project', {
      attrs: {
        "project": project
      }
    })
  }))])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e905904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PortfolioContent.vue
// module id = 205
// module chunks = 0